export const initServicePoints = () => {
  const sections = document.querySelectorAll(".js-service-points");

  for (const section of sections) {
    const buttons = section.querySelectorAll(".js-service-point-button");
    const contents = section.querySelectorAll(".js-service-point-content");
    const map = section.querySelector(".js-service-points-map");
    const status = section.querySelector(".js-service-points-status");
    const canHover = window.matchMedia("(hover: hover) and (pointer: fine)");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const sectionStyles = getComputedStyle(section);
    const accentColor =
      sectionStyles.getPropertyValue("--service-accent").trim() || "#ef8200";
    const inverseColor =
      sectionStyles.getPropertyValue("--color-text-inverse").trim() || "#fff";
    let hoveredPoint = "";
    let focusedPoint = "";

    if (buttons.length === 0 || contents.length === 0 || !map || !status) {
      continue;
    }

    const getMapDocument = () => {
      try {
        return map.contentDocument;
      } catch {
        return null;
      }
    };

    const bringMapConnectorsForward = () => {
      const mapDocument = getMapDocument();
      const mapLayer = mapDocument?.getElementById("map");

      if (!mapLayer) {
        return;
      }

      const connectors = mapLayer.querySelectorAll(
        ":scope > line, :scope > polyline, :scope > ellipse",
      );

      for (const connector of connectors) {
        mapLayer.append(connector);
      }
    };

    const syncMapPoints = () => {
      const mapDocument = getMapDocument();

      if (!mapDocument) {
        return;
      }

      for (const button of buttons) {
        const pointNumber = button.dataset.servicePoint ?? "";
        const pointGroup = mapDocument.getElementById(
          `button${pointNumber.padStart(2, "0")}`,
        );
        const isInverted =
          button.getAttribute("aria-pressed") === "true" ||
          pointNumber === hoveredPoint ||
          pointNumber === focusedPoint;

        if (!pointGroup) {
          continue;
        }

        const circle = pointGroup.querySelector("ellipse");
        const numberPaths = pointGroup.querySelectorAll("path");
        const fillTransition = reducedMotion.matches
          ? "none"
          : "fill 0.3s ease";

        if (circle) {
          circle.style.transition = fillTransition;

          if (isInverted) {
            circle.style.fill = accentColor;
          } else {
            circle.style.removeProperty("fill");
          }
        }

        for (const numberPath of numberPaths) {
          numberPath.style.transition = fillTransition;

          if (isInverted) {
            numberPath.style.fill = inverseColor;
          } else {
            numberPath.style.removeProperty("fill");
          }
        }
      }
    };

    map.addEventListener("load", () => {
      bringMapConnectorsForward();
      syncMapPoints();
    });
    reducedMotion.addEventListener("change", syncMapPoints);

    const closeAll = () => {
      for (const button of buttons) {
        button.setAttribute("aria-pressed", "false");
        button.setAttribute(
          "aria-label",
          `ポイント${button.dataset.servicePoint}を表示`,
        );
      }

      for (const content of contents) {
        content.classList.remove("is-active");
      }
    };

    for (const button of buttons) {
      button.addEventListener("mouseenter", () => {
        if (!canHover.matches) {
          return;
        }

        hoveredPoint = button.dataset.servicePoint ?? "";
        syncMapPoints();
      });

      button.addEventListener("mouseleave", () => {
        hoveredPoint = "";
        syncMapPoints();
      });

      button.addEventListener("focus", () => {
        focusedPoint = button.dataset.servicePoint ?? "";
        syncMapPoints();
      });

      button.addEventListener("blur", () => {
        focusedPoint = "";
        syncMapPoints();
      });

      button.addEventListener("click", () => {
        const pointNumber = button.dataset.servicePoint;
        const target = section.querySelector(
          `.js-service-point-content[data-service-point="${pointNumber}"]`,
        );
        const willOpen = button.getAttribute("aria-pressed") !== "true";

        closeAll();

        if (!willOpen || !target) {
          status.textContent = `ポイント${pointNumber}を閉じました。`;
          syncMapPoints();
          return;
        }

        button.setAttribute("aria-pressed", "true");
        button.setAttribute("aria-label", `ポイント${pointNumber}を閉じる`);
        target.classList.add("is-active");
        status.textContent = button.dataset.announcement ?? "";
        syncMapPoints();
      });
    }

    section.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") {
        return;
      }

      closeAll();
      status.textContent = "ポイントの説明を閉じました。";
      syncMapPoints();
    });

    bringMapConnectorsForward();
    syncMapPoints();
  }
};
